<template>
  <div>
    <h1>企業簽單</h1>
    <Form v-model="form" :label-width="80">
      <FormItem label="簽單日期">
        <Row>
          <Col span="3">
            <DatePicker
              v-model="form.selectedStartDate"
              @on-change="setStartDate"
              @on-clear="selectedStartDate = null"
              type="date"
              placeholder="開始日期"
              class="datePicker"
            >
            </DatePicker>
          </Col>
          <Col span="1" style="text-align: center">~</Col>
          <Col span="3">
            <DatePicker
              v-model="form.selectedEndDate"
              @on-change="setEndDate"
              @on-clear="selectedEndDate = null"
              type="date"
              placeholder="結束日期"
              class="datePicker"
            >
            </DatePicker>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="部門">
        <Select
          v-model="form.department"
          style="width:29%"
          placeholder="請選擇"
        >
          <Option
            v-for="department in departmentList"
            :value="department"
            :key="department"
            >{{ department }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="關鍵字">
        <Input
          v-model="form.keyword"
          style="width: 29%"
          size="large"
          placeholder="工號/單號/簽單備註"
        />
      </FormItem>
      <FormItem>
        <Button type="success" :loading="isLoadingSearch" @click="searchDate">
          <Icon type="md-search" size="20" />搜尋
        </Button>
        <Button type="error" @click="clearData">
          <Icon type="ios-download-outline" size="20" />清空條件
        </Button>
        <Button type="primary" @click="downloadExcelOrder">
          <Icon type="ios-download-outline" size="20" />下載簽單
        </Button>
      </FormItem>
    </Form>
    <Table
      stripe
      border
      no-data-text="暫無資料"
      :columns="columns"
      :data="orders"
      :loading="isLoadingSearch"
      @on-row-click="showOrderInfo"
    >
      <template slot-scope="{ row }" slot="abnormalNote">
        <Tooltip v-if="row.abnormalArray.length" placement="top">
          <Icon size="40" color="red" type="md-warning" />
          <template #content>
            <ol>
              <li v-for="abnormalNote of row.abnormalArray">
                {{ abnormalNote }}
              </li>
            </ol>
          </template>
        </Tooltip>
      </template>
      <template slot-scope="{ row, index }" slot="fee">
        <div
          v-if="row.taxiFixedFare"
          style="width: fit-content; margin: 0 auto"
        >
          <h5 style="font-size:0.8rem">
            {{ row.actualFare + row.serviceFare }}
          </h5>
          <p>固定車資：{{ row.taxiFixedFare }}</p>
          <p>跳錶車資：{{ row.actualFare - row.taxiFixedFare }}</p>
          <p>服務費：{{ row.serviceFare }}</p>
        </div>
        <div v-else style="width: fit-content; margin: 0 auto">
          <h5 style="font-size:1rem">{{ row.actualFare + row.serviceFare }}</h5>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" @click="showOrderInfo(row)">查看訂單</Button>
        <template v-for="image in row.employeeImage">
          <img
            v-if="image && image.includes('http')"
            width="100"
            height="120"
            :src="image"
            alt="企業簽單圖片"
            @click="showModal(image)"
          />
        </template>
      </template>
    </Table>
    <div class="paginationContainer page-position">
      <Page
        :current="page.currentPage"
        :total="page.totalEntries"
        :page-size="page.perPage"
        @on-change="changePage"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import API from '../asset/js/API'
import jsCookie from 'js-cookie'
import dayjs from 'dayjs'
import { orderListCol } from '../constants/orderListCol'

export default {
  data () {
    return {
      form: {
        initStartDate: null,
        selectedStartDate: null,
        selectedEndDate: null,
        keyword: '',
        department: null
      },
      columns: orderListCol,
      page: {
        totalEntries: 0,
        currentPage: 1,
        perPage: 25
      },
      orders: [],
      isLoadingSearch: false,
      departmentList: []
    }
  },
  mounted () {
    this.clearData()
    this.initDate()
    this.getDepartment()
  },
  methods: {
    changePage (currentPage) {
      this.page.currentPage = currentPage
      this.getSigningList(currentPage)
    },
    initDate () {
      this.form.initStartDate = dayjs().format('YYYY-MM-DD')
      this.form.selectedStartDate = this.form.initStartDate
      this.form.selectedEndDate = this.form.initStartDate
    },
    setStartDate (date) {
      this.form.selectedStartDate = date
      // console.log("開始日期參數", this.selectedStartDate);
    },
    setEndDate (date) {
      this.form.selectedEndDate = date
      // console.log("結束日期參數", this.selectedEndDate);
    },
    showOrderInfo (row) {
      if (this.$route.path !== `/order/${row.id}`) {
        this.$router.push(`/order/${row.id}`)
      }
    },
    handleChange (daterange) {
      this.dataValue = daterange
    },
    async getDepartment () {
      try {
        const { result } = await API.get(`/order/department`)
        this.departmentList = result
      } catch (error) {
        console.error(error)
      }
    },
    async getSigningList (page = 1) {
      const { selectedStartDate, selectedEndDate } = this.form
      if (selectedStartDate === null || selectedStartDate === '') {
        this.form.selectedStartDate = this.form.initStartDate
        this.form.selectedEndDate = this.form.initStartDate
        this.$Message.error({
          content: '請選擇起始時間',
          top: 50,
          duration: 3,
          closable: true
        })
      } else if (selectedEndDate === null || selectedEndDate === '') {
        this.form.selectedStartDate = this.form.initStartDate
        this.form.selectedEndDate = this.form.initStartDate
        this.$Message.error({
          content: '請選擇結束時間',
          top: 50,
          duration: 3,
          closable: true
        })
      } else if (
        dayjs(selectedEndDate)
          .subtract(1, 'year')
          .isSameOrAfter(dayjs(selectedStartDate).format('YYYY-MM-DD'))
      ) {
        this.$Message.error({
          content: '只能查詢一年內的資料',
          top: 50,
          duration: 3,
          closable: true
        })
        this.clearData()
        this.form.selectedEndDate = selectedEndDate
      } else {
        this.isLoadingSearch = true
        try {
          const start_date = dayjs(this.form.selectedStartDate)
            .startOf('day')
            .subtract(8, 'hour')
            .format('YYYY-MM-DD HH:mm')
          const end_date = dayjs(this.form.selectedEndDate)
            .endOf('day')
            .subtract(8, 'hour')
            .format('YYYY-MM-DD HH:mm')
          const { result } = await API.get(
            `/order/?per_page=${
              this.page.perPage
            }&current_page=${page}&start_date=${start_date}&end_date=${end_date}&keyword=${
              this.form.keyword
            }${
              this.form.department ? '&department=' + this.form.department : ''
            }`
          )
          this.orders = result.data.map(order => {
            return {
              ...order,
              orderDate: dayjs(order.orderDate).format('YYYY-MM-DD HH:mm:ss'),
              driverNameAndCallNumber: `${order.driverCallNumber}/${order.driverName}`
            }
          })
          const { totalEntries, perPage, currentPage } = result.paging
          this.page.currentPage = currentPage
          this.page.totalEntries = totalEntries
          this.page.perPage = perPage
        } catch (error) {
          this.$Message.error({
            content: '發生錯誤請稍後再試',
            top: 50,
            duration: 3,
            closable: true
          })
          console.error(error)
        } finally {
          this.isLoadingSearch = false
        }
      }
    },
    async downloadExcelOrder () {
      if (
        this.form.selectedStartDate === '' ||
        this.form.selectedEndDate === '' ||
        this.form.selectedStartDate === null ||
        this.form.selectedEndDate === null
      ) {
        this.form.selectedEndDate = this.form.initStartDate
        this.$Message.error({
          content: '請輸入起始與結束時間',
          top: 50,
          duration: 3,
          closable: true
        })
      } else {
        const token = jsCookie.getJSON('token')
        // 下載excel表單的起始與結束時間皆為
        // UTC+0，所以時間都必須減8小時
        const startDate = dayjs(this.form.selectedStartDate)
          .subtract(8, 'hour')
          .format('YYYY-MM-DD HH:mm:ss')
        // 結束日期加上一天是為了包含結束時間當天的訂單
        const endDate = dayjs(this.form.selectedEndDate)
          .add(1, 'day')
          .subtract(8, 'hour')
          .subtract(1, 'second')
          .format('YYYY-MM-DD HH:mm:ss')
        const downloadBaseUrl = location.href.includes(
          'enterprise.backstage.gladmobile'
        )
          ? 'https://download.gladmobile.com'
          : 'https://staging.download.gladmobile.com'
        const url = `${downloadBaseUrl}/web/api/excel/enterprise_order-excel?token=${token}&start_date=${startDate}&end_date=${endDate}${
          this.form.keyword ? '&keyword=' + this.form.keyword : ''
        }${this.form.department ? '&department=' + this.form.department : ''}`
        try {
          await axios.get(url)
          window.open(url, '_blank').focus()
        } catch (e) {
          console.error(e.response)
          this.$Message.warning(e.response.data.error.message)
        }
      }
    },
    searchDate () {
      this.getSigningList()
    },
    clearData () {
      this.form.selectedStartDate = null
      this.form.selectedEndDate = null
      this.form.keyword = ''
      this.form.department = null
      this.page = {
        totalEntries: 0,
        currentPage: 1,
        perPage: 25
      }
      this.orders = []
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/pagination.scss";

// 修改 iview table css，滑鼠移到 table row 時出現手指
.ivu-table-row {
  cursor: pointer;
}

.page-position {
  padding-top: 10px;
}

// 當hover到異常的三角形icon變成pointer
.ivu-icon:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue